import { IconLocationGroup } from '@/src/assets/icons'
import { MenuButton } from '@/src/components/ui/Menu'
import { appColors } from '@/src/theme/foundations/colors'
import { Flex, Text } from '@chakra-ui/react'
import { FaRegBuilding } from 'react-icons/fa6'
import { MdOutlineLocationOn } from 'react-icons/md'
import { RxCaretDown, RxCaretUp } from 'react-icons/rx'
import type { ILocationSelectMenuButtonLabels } from '..'
import { BaseButton } from '../buttons/BaseButton'

interface LocationSelectButtonProps {
  isOpen: boolean
  menuButtonLabels: ILocationSelectMenuButtonLabels
  disabled?: boolean
  showLocationLabel?: boolean
  showBuildingLabel?: boolean
}
export const LocationSelectButton = ({ isOpen, menuButtonLabels, disabled = false }: LocationSelectButtonProps) => {
  return (
    <Flex id='location-selector'>
      <MenuButton as={BaseButton} variant='secondary' isDisabled={disabled}>
        <Flex alignItems='center' gap={2} fontWeight={500}>
          <Flex h='24px' gap={1} alignItems='center'>
            <IconLocationGroup color={menuButtonLabels.location ? undefined : appColors.primary} />

            <Text fontSize={14} maxW='280px' isTruncated color={menuButtonLabels.location ? undefined : appColors.primary}>
              {menuButtonLabels.region}
            </Text>
          </Flex>

          {menuButtonLabels.location && (
            <>
              <Flex gap={1} alignItems='center'>
                <MdOutlineLocationOn size={20} color={menuButtonLabels.building ? undefined : appColors.primary} />
                <Text fontSize={14} maxW='280px' isTruncated color={menuButtonLabels.building ? undefined : appColors.primary}>
                  {menuButtonLabels.location}
                </Text>
              </Flex>
            </>
          )}

          {menuButtonLabels.building && (
            <>
              <Flex gap={1} alignItems='center'>
                <FaRegBuilding color={appColors.secondary} />
                <Text fontSize={14} maxW='280px' isTruncated color={appColors.primary}>
                  {menuButtonLabels.building}
                </Text>
              </Flex>
            </>
          )}

          {isOpen ? <RxCaretUp size={28} /> : <RxCaretDown size={24} />}
        </Flex>
      </MenuButton>
    </Flex>
  )
}
